import {
  TRUCK_TYPE_SHORT_LABELS,
  isTruckTypeSlug,
  type TruckTypeSlug,
} from "@/lib/truck-types";

export interface EnabledTruck {
  slug: TruckTypeSlug;
  label: string;
  units?: number;
}

export function getEnabledTrucksFromCapacities(
  truckCapacities: Record<string, unknown> | null | undefined,
): EnabledTruck[] {
  if (!truckCapacities) return [];
  const result: EnabledTruck[] = [];
  for (const [key, raw] of Object.entries(truckCapacities)) {
    if (
      key === "custom" ||
      !raw ||
      typeof raw !== "object" ||
      Array.isArray(raw)
    )
      continue;
    if (!isTruckTypeSlug(key)) continue;
    if (!("enabled" in raw) || !raw.enabled) continue;
    const units = "units" in raw ? raw.units : undefined;
    result.push({
      slug: key,
      label: TRUCK_TYPE_SHORT_LABELS[key] ?? key,
      units: typeof units === "number" ? units : undefined,
    });
  }
  return result;
}
